import LoadingAnimation from "@assets/svg/LoadingAnimation";
import PlusIcon from "@assets/svg/PlusIcon";
import CustomInput from "@components/CustomInput/CustomInput";
import InviteReferralMemberModal from "@components/InviteReferralMemberModal/InviteReferralMemberModal";
import { updateReferralAccountApi } from "@endpoints/referral.service";
import { RootState } from "@store/reducers";
import { isNullOrEmpty } from "@utils/helperFunction";
import regexList from "@utils/regexList";
import { useSnackbar } from "notistack";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";

const ReferralMember = () => {
  const { enqueueSnackbar } = useSnackbar();
  const user = useSelector((state: RootState) => state.auth.user);
  const {
    control,
    formState: { errors, isDirty },
    handleSubmit,
    reset,
    setValue,
    watch,
    trigger,
  } = useForm({
    defaultValues: {
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.email,
      phoneNo: user.phoneNo ?? "N/A",
      userName: user.userName,
      referralName: !isNullOrEmpty(user?.referralDetail?.firstName)
        ? user?.referralDetail?.firstName + " " + user?.referralDetail?.lastName
        : "",
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      inviteReferralAccountEmail: undefined,
      isLoadingInviteReferaalAccount: false,
    },
  });
  const fields = watch();

  const [isEditing, setIsEditing] = useState(false);
  const [isInviteModalOpen, setIsInviteModalOpen] = useState(false);
  const [isChangeReferralModalOpen, setIsChangeReferralModalOpen] =
    useState(false);

  const handleInviteClick = () => {
    setIsInviteModalOpen(true);
  };

  const handleChangeReferralClick = () => {
    setIsChangeReferralModalOpen(true);
  };

  const handleCloseInviteModal = () => {
    setIsInviteModalOpen(false);
  };

  const updateReferralAccount = async (params) => {
    try {
      setValue("isLoadingInviteReferaalAccount", true);

      const { success, data } = await updateReferralAccountApi(params);
      if (success) {
        enqueueSnackbar("Invited sucessfully.", {
          variant: "success",
        });
        setIsInviteModalOpen(false);
        setIsChangeReferralModalOpen(false);
      }
    } catch (error) {
      enqueueSnackbar(error, {
        variant: "error",
      });
    } finally {
      setValue("isLoadingInviteReferaalAccount", false);
    }
  };

  return (
    <div className="flex-1 bg-white p-6 rounded-md border border-gray-200 text-xs h-fit">
      <p className="text-xs font-semibold mb-1">Your Referral Member</p>
      <div className="mb-8 flex items-center">
        <div className="flex-grow">
          {/* @ts-ignore */}
          <CustomInput
            name="referralName"
            control={control}
            errors={errors}
            disabled={!isEditing}
            rules={{
              required: "This field is required.",
            }}
          />
        </div>
        {!isNullOrEmpty(user?.referralDetail?.firstName) && (
          <button
            className="text-xs text-primary ml-5 h-9 flex items-center"
            onClick={handleChangeReferralClick}
          >
            {isEditing ? "Update" : "Change"}
          </button>
        )}
      </div>

      <div className="py-2.5 px-3 h-10 rounded-lg bg-light-white-700 border border-lightgray font-montserrat font-medium text-xs">
        {`${
          !isNullOrEmpty(user?.referralDetail?.userName)
            ? `https://comtracked/profile/${user?.referralDetail?.userName}`
            : ""
        }`}
      </div>
      <button
        onClick={handleInviteClick}
        className="flex items-center gap-2 mt-5 font-medium bg-primary text-xs text-white rounded-md py-2 px-4 hover:bg-black"
      >
        <PlusIcon className={"w-4 h-4"} fill={"white"} /> Invite referral member
      </button>

      <InviteReferralMemberModal
        openModal={isInviteModalOpen}
        setOpenModal={setIsInviteModalOpen}
      />
      {false && (
        <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 flex flex-col rounded-md w-[30%]">
            <button
              onClick={handleCloseInviteModal}
              className="flex self-end text-black text-2xl font-semibold"
            >
              X
            </button>
            <h2 className="text-lg font-semibold mb-8">
              Invite referral member
            </h2>
            {/* @ts-ignore */}
            <CustomInput
              name="inviteReferralAccountEmail"
              control={control}
              errors={errors}
              label="Enter email address of Referral member"
              rules={{
                required: "This field is required.",
                pattern: {
                  value: regexList.email,
                  message: "Invalid email address",
                },
              }}
            />
            <div className="flex flex-col">
              <button
                onClick={() =>
                  updateReferralAccount({
                    referralEmail: fields?.inviteReferralAccountEmail,
                  })
                }
                disabled={
                  !regexList.email.test(fields?.inviteReferralAccountEmail) ||
                  fields.isLoadingInviteReferaalAccount
                }
                className={`flex self-end gap-2 mt-28 font-medium bg-primary justify-center items-center text-xs text-white rounded-md py-2 px-4 hover:bg-black ${
                  regexList.email.test(fields?.inviteReferralAccountEmail)
                    ? "opacity-100"
                    : "opacity-30"
                }`}
              >
                {fields.isLoadingInviteReferaalAccount && <LoadingAnimation />}
                Invite
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReferralMember;
